// File: /sanity/lib/image.ts
import createImageUrlBuilder from '@sanity/image-url';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';
import { dataset, projectId } from '../env';

// Reużywalny builder
const builder = createImageUrlBuilder({ projectId, dataset });

/** Zostawiamy dla kompatybilności */
export const urlFor = (source: SanityImageSource) => builder.image(source);

/** Produkcyjny helper: lekki url + mini blur */
export function buildSanityImage(
    source: SanityImageSource,
    opts: {
      w: number;
      h: number;
      q?: number; // default 70
      dpr?: 1 | 2; // default 2 na retina
      fit?: 'crop' | 'min' | 'max' | 'fill' | 'clip';
    }
) {
  const { w, h, q = 70, dpr = 2, fit = 'crop' } = opts;

  const src = urlFor(source)
      .width(w)
      .height(h)
      .fit(fit)
      .auto('format') // AVIF/WEBP gdy możliwe
      .quality(q)
      .dpr(dpr)
      .url();

  // malutki blur jako placeholder (szybszy niż lqip po GROQ)
  const blurDataURL = urlFor(source)
      .width(24)
      .height(Math.max(1, Math.round((h / w) * 24)))
      .fit(fit)
      .auto('format')
      .quality(20)
      .dpr(1)
      .url();

  return { src, blurDataURL, width: w, height: h };
}